export default __webpack_public_path__ + "static/media/camera-o.4de3179c.svg";